export const subTaskNameConstants: Record<string, string> = {
    rawFeedReportGenerate: 'RawFeedReportGenerate',
    rawFeedValidate: 'RawFeedValidate',
    rawFeedUpload: 'RawFeedUpload',
    rawFeedImgProcessReportGenerate: 'RawFeedImgProcessReportGenerate'
};

export const step4SubTaskNameConstants: Record<string, string> = {
    productTypeSubTypeGeneration: 'productTypeSubTypeGeneration',
    styleGeneration: 'styleGeneration',
    rawFeedReportGenerate: 'RawFeedReportGenerate',
};
